



























































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import ProductCustomizationMixin, {
  ProductCustomizationMixinTags,
} from "@/mixins/http/ProductCustomizationMixin";
import VModal from "./VModal.vue";
import { customizationStore } from "@/store/typed";
import { easync } from "@/helpers/http";

@Component({
  components: {
    VModal,
  },
})
export default class TermsModal extends Mixins(ProductCustomizationMixin) {
  @Prop({ default: "" }) title?: string;

  modal!: VModal;

  private accepted = false;
  private error = false;

  mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  protected async onConfirm() {
    const productCustomization = customizationStore.productCustomization;
    const [data, errors] = await easync(
      this.setProductCustomizationTerms({ id: productCustomization.uuid })
    );
    customizationStore.setProductCustomizationTerms(true);

    if (data) {
      this.error = false;
      this.modal.hide();
    } else {
      this.error = true;
    }
  }

  show() {
    this.modal.show();
  }
}
